import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const once = useRef(false);

  useEffect(() => {
    if (once.current) return;
    once.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/"); return; }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const account_type = localStorage.getItem("velocity_signup_type") || undefined;
        const { data } = await api.post("/auth/google-session", { session_id, ref: localStorage.getItem("velocity_ref") || undefined, account_type });
        localStorage.removeItem("velocity_signup_type");
        setUser(data);
        const dest = { driver: "/browse", host: "/list-your-car", business: "/partners/apply", community: "/community" }[account_type] || "/dashboard";
        window.history.replaceState({}, "", dest);
        nav(dest, { replace: true });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return <div className="min-h-screen flex items-center justify-center text-slate-400" data-testid="auth-callback-page">Signing you in…</div>;
}
